// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2_Esk","label":"Radio_label__3e78G","checkMark":"Radio_checkMark__1qFHW","disabled":"Radio_disabled___zSqZ"};